import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  root: {
    cursor: 'pointer',
    '.button': {
      color: 'inherit',
      fontSize: 'inherit',
      fontWeight: 'inherit',
      textTransform: 'inherit',
      whiteSpace: 'unset',
    },
  },
});

export default useSx;
